import React from 'react';
import DocumentExplorer from '../components/documents/DocumentExplorer';
import { useThemeStore } from '../stores/themeStore';

export default function Documents() {
  const { darkMode } = useThemeStore();
  
  return (
    <div>
      <h1 className={`text-2xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'} mb-8`}>Documents</h1>
      <DocumentExplorer />
    </div>
  );
}